import {injectIntl} from "react-intl";
import {useContext, useEffect, useState} from "react";
import AwsIot from "aws-iot-device-sdk";
import {MQTTPermissionsContext} from "../permissions/MQTTPermissionsContext";
import {MAX_RECONNECT} from "./Constants";

const MQTTUtility = (props) => {
    const {config, topic, onMessage, setError, setIsSubscribing} = props;
    const {refreshConnectionDetails} = useContext(MQTTPermissionsContext);
    const [connecting, setConnecting] = useState(false)
    let retryCount = 0
    let mqttClient = null;

    const connectToMQTT = () => {
        refreshConnectionDetails().then(data => {
            config.accessKeyId = data.loginId
            config.secretKey = data.loginKey
            config.sessionToken = data.sessionToken
            setConnecting(true)

            if (!connecting) {
                mqttClient = AwsIot.device(config)

                mqttClient.on('error', async (error) => {
                    console.error("Error occurred in MQTT connection : ", error)
                    disconnectToMQTT()
                    handleConnectionError()
                })

                mqttClient.on('connect', ()  => {
                    console.log("Connected to AWS IoT Client.", mqttClient)
                    retryCount = 0;
                    if (mqttClient) {
                        mqttClient.subscribe(topic)
                    }
                    setError(false)
                    setConnecting(false)
                })

                mqttClient.on('message', (topic, message) => {
                    if (mqttClient) {
                        onMessage(message)
                    }
                })

                mqttClient.on('reconnect', async () => {
                    if (++retryCount > MAX_RECONNECT) {
                        console.error("Maximum attempts to connect to MQTT client reached, suspending re-connection.")
                        disconnectToMQTT()
                        handleConnectionError()
                    }
                })
            }
        }).catch(error => {
            console.error("Error connecting to MQTT client with config : ", config, error)
            disconnectToMQTT()
            handleConnectionError()
        })
    }

    const disconnectToMQTT = () => {
        if (mqttClient) {
            console.log("Disconnecting to AWS IoT Client")
            mqttClient.unsubscribe(topic)
            mqttClient.end()
            mqttClient = null
        }
    }

    const handleConnectionError = () => {
        setError(true)
        setIsSubscribing(false)
    }

    useEffect(() => {
        connectToMQTT()
        return () => {
            disconnectToMQTT()
        }
    }, []);

    return true;
}

export default injectIntl(MQTTUtility)


// WEBPACK FOOTER //
// ./src/components/util/MQTTUtility.js